let config = {
  url: "https://teachdigital.dev",
  consumerKey: "ck_24139d93d340a91d6db56bf6470f7a2ef2315902",
  consumerSecret: "cs_d420e33a950197a012e85091d8b1d42c7c59a7dd",
  version: "wc/v3"
}

module.exports = {
	config
}